import React, {createContext, useContext, useMemo} from 'react';

const defaultImportTableContext = {
    onRowsStatusSort: (status) => {},
    onExportDownload: () => {},
    getSortableFieldValues: (name) => {},
}

const ImportTableContext = createContext(defaultImportTableContext);

export function useImportTableContext() {
    return useContext(ImportTableContext);
}

export default function ImportTableProvider({children, ...props}) {
    const valuesToShare = useMemo(() => ({
        ...props,
    }), [props]);

    return (
        <ImportTableContext.Provider value={valuesToShare}>
            {children}
        </ImportTableContext.Provider>
    )
}
